(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'RequestInfo',
	};

	var cruise_lines = null;
	var ships        = null;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		cruise_lines = $('#requestinfo-cruise_line');
		ships        = $('#requestinfo-ship');

		// load ships when changing the cruise line
		cruise_lines.change(function onCruiseLineChange(event) {
			var cruise_line_id = parseInt($(this).val());

			if (cruise_line_id) {
				_loadShips(cruise_line_id);
			} else {
				ships.empty();
			}
		});
	};

	function _loadShips(cruise_line_id)
	{
		var url = '/Ships/shipsByCruiseLine/' + cruise_line_id;

		ships.empty()
			 .append('<option selected="1">Any Ship</option>');

		Adzuki.Ajax.get(url).then(function getShips(cruise_line_ships) {
			$.each(cruise_line_ships, function onEachShip(index, current_ship) {
				var markup = '';
				markup += '<option value="' + current_ship.id + '">';
				markup += current_ship.name;
				markup += '</option>';

				ships.append(markup);
			});
		});
	}
}(jQuery, window.Adzuki || {}));
